import general from '../../utils/general';
import { useState } from 'react';
import { translations, LanguageKeys } from './translation';

export const useController = () => {
    const [account, setAccount] = general.zustand((state: any) => [state.account, state.setAccount]);
    const [loginData, setLoginData] = useState({ email: '', password: '' });
    const [loading, setLoading] = useState(false);
    const [currentLanguage, setCurrentLanguage] = useState<LanguageKeys>((general.getBrowserLanguage() == 'PTBR' ? 'PTBR' : 'EN') as LanguageKeys);
    const [choosingOptions, setChoosingOptions] = useState(true);
    const allLanguageCodes = general.languages.map((lang) => lang.code) as LanguageKeys[];

    const handleChange = (event: any) => {
        setLoginData({ ...loginData, [event.target.name]: event.target.value });
    }

    return { 
        general,
        handleChange, 
        currentLanguage,
        loading 
    }
}

export default useController;